<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option" :route="route"
           :width="width" :extendData="extendData" style="position: absolute"></Chart>
    <div style="position: absolute;top:80%;left: 0;text-align: center;width: 100%">
      <span v-if="tagCode === 'elec'">总能耗值：{{ power }} kw·h</span> <span v-else>总用水量：{{ power }} m³</span> <span style="padding-left: 80px">IT设备能耗值：{{ itPower }} kw·h</span>
    </div>

  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "GaugeChart",
  components: {Chart},
  props: {
    data: null,
    extendData: null,
    route: {
      type: String,
      default: ""
    },
    pueValue: {
      type: Number,
      default: () => 0
    },
    itPower: {
      type: Number,
      default: () => 0
    },
    power: {
      type: Number,
      default: () => 0
    },
    id: {
      type: String,
      default: () => 'pueChart'
    },
    tagCode: {
      type: String,
      default: () => 'elec'
    }
  },
  data() {
    return {
      width: '100%',
      height: '74%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      this.option = {
        tooltip: {
          formatter: "{a} : {c}"
        },
        series: [{
          name: this.tagCode === 'elec' ? 'PUE实时值' : 'WUE实时值',
          type: 'gauge',
          center: ['50%', '60%'],
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 3,
          radius: '120%',
          splitNumber: 1,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          pointer: {
            length: '50%',
            width: 8,
          },
          axisLine: {
            lineStyle: {
              color: [
                [1 / 3, 'rgba(95, 227, 161)'],
                [2 / 3, 'rgba(254, 193, 99)'],
                [1, 'rgba(255, 131, 115)']
              ],
              width: 25,
            },
          },
          detail: {
            formatter: '{value}',
            textStyle: {
              fontSize: 22,
            }
          },
          title: {
            show: false
          },
          data: [{
            value: this.pueValue,        // (zom0 / zom1).toFixed(2) - 0
            name: this.pueValue
          }]
        }]
      };
    },
  },
}
</script>

<style scoped>

</style>
